// API endpoints per environment. Defaults to `development` (unchanged behaviour);
// set REACT_APP_ENV=production at build time to target the live APIs without
// editing this file.
const ENV = process.env.REACT_APP_ENV || 'development';

const URLS = {
  development: {
    base_url: 'http://localhost:8181/',
    onsite_url: 'http://localhost:8185/',
    cms_api_base_url: 'http://localhost:8081/',
  },
  production: {
    base_url: 'https://www.adminapi.scientexconference.com/',
    onsite_url: 'https://www.conference-management-api.scientexconference.com/',
    cms_api_base_url: 'https://www.cmsapi.scientexconference.com/'
  },
};

// safe fallback
const obj = URLS[ENV] || URLS.development;

// exports
export const base_url = obj.base_url;
export const onsite_url = obj.onsite_url;
export const cms_base_url = obj.cms_api_base_url;
export const env = ENV;

export default obj.base_url;
